import React from "react";
import ConfirmDocuments from "../../views/ConfirmDocuments/ConfirmDocuments";
import UploadService from "../../services/UploadService";

const ConfirmDocumentsNP = () => {
    return <ConfirmDocuments uploadAction={UploadService.uploadStatementNaturalPerson}/>
}
export default ConfirmDocumentsNP;
